import React,{Suspense} from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import "./Resources/bootstrap/dist/new_css/bootstrap.css";
import './i18n'
import swDev from './swDev'
import secureLocalStorage from 'react-secure-storage';
import loadingTranslation from "../src/loadingTranslation.json"
import { formStateStore } from './Redux/Store/store';
import { updateContainerInfo } from './Redux';
import { reset, updateStateInRedux } from './Redux/Actions/FormStateActions';
import { loadConfig } from './url';//Please don't remove this line
// import App from "./App"
const App= React.lazy(()=> import("./App"));

function getExternalFilesPaths(){
  if(window?.getExternalJSPaths){
    var filePaths= window?.getExternalJSPaths();
    if( filePaths && filePaths.length > 0 ){
      for(let fileIndex=0 ; fileIndex < filePaths.length; fileIndex++  ){

        const path = `${process.env.REACT_APP_PUBLIC_URL}${filePaths[fileIndex]}?version=${Math.floor(Math.random()*10000)}`;

        if(path){
          var script = document.createElement('script');
          script.setAttribute('src', path);
          script.setAttribute('id', `iformClient_js_newapplyonline${fileIndex}`);
          document.body.appendChild(script);
        }
      }
    }
  }
}

function loadIformClient(){
  const isIformClientLoaded = document.querySelector(`script[src="${process.env.REACT_APP_PUBLIC_URL}/iformclient.js"]`);
  if(isIformClientLoaded===null){
    const iformClient_url= `${process.env.REACT_APP_PUBLIC_URL}/iformclient.js?version=${Math.floor(Math.random()*10000)}`;
    var script = document.createElement('script');
    script.setAttribute('src', iformClient_url);
    script.setAttribute('id', "iformClient_js_newapplyonline");
    script.onload= () =>{ 
      getExternalFilesPaths();
    }
    document.body.appendChild(script);
  }
}

const localeKey=secureLocalStorage.getItem("locale");
    if(localeKey){
      localStorage.setItem("locale",localeKey);
      if(window?.newapplyonline_configs?.selectedLanguage)
        window.newapplyonline_configs.selectedLanguage= localeKey || navigator.language || navigator.userLanguage;
    }
      
const translationStyles1=window?.newapplyonline_configs?.selectedLanguage;
  if(process.env.REACT_APP_PUBLIC_URL === "/newapplyonline"){
    loadIformClient();
  }



function loadIdesignfrm(){
  const idesignfrmLoaded = document.querySelector(`script[src="${process.env.REACT_APP_PUBLIC_URL}/idesignfrm.js"]`);
  if(idesignfrmLoaded===null){
    const idesignfrm_url= `${process.env.REACT_APP_PUBLIC_URL}/idesignfrm.js`;
    var script = document.createElement('script');
    script.setAttribute('src', idesignfrm_url);
    script.setAttribute('id', "idesignfrm_js_newapplyonline");
    document.body.appendChild(script);
  }
}
  loadIdesignfrm();

function loadInterfaceUtil(){
  const isInterfaceUtilLoaded = document.querySelector(`script[src="${process.env.REACT_APP_PUBLIC_URL}/interfaceutil.js"]`);
  if(isInterfaceUtilLoaded===null){
    const interfaceUtil_url= `${process.env.REACT_APP_PUBLIC_URL}/interfaceutil.js`;
    var script = document.createElement('script');
    script.setAttribute('src', interfaceUtil_url);
    script.setAttribute('id', "interfaceutil_js_newapplyonline");
    document.body.appendChild(script);
  }
}
if(process.env.REACT_APP_PUBLIC_URL === "/newapplyonline"){
  loadInterfaceUtil()
}

window.setContainerId = (containerId) => {
  if(containerId==="ngform") {
    window.istaskOpen= true;
  }
  else{
    window.istaskOpen= false;
  }
  formStateStore.dispatch(updateContainerInfo({ key: containerId }))
}

getExternalFilesPaths();

// ***********************************  MicroFrontend component implementation for MDM Module **************************************
window.renderPreview = async (containerId, props) => {

    if(props.ContainerId==="ngform"){
      window.istaskOpen= true;
    }
    else{
      window.istaskOpen= false;
    }
    window.formLoaderRan = false;
    window.langChange = false; // when lang is present in QueryParam 
    if(document.getElementById(containerId)) {
      formStateStore.dispatch(reset({key: containerId,formState: {}, resetContainerId: containerId}));
      formStateStore.dispatch(updateStateInRedux({name:"generalDataCall",value: false}));
      const unloaded_app= await window.unmountPreviewManual(containerId);
      console.log(unloaded_app);
    }

    if(props.passedData.formMataData_json){
      
      // setTimeout(() => {

        ReactDOM.render(
          <Suspense fallback={<div className="Loading_fallback"> {loadingTranslation[translationStyles1] || "Loading ...."}</div>}>
            <App 
              childComp="preview" 
              history={props} 
              data={props.passedData} 
              formMataData={props.passedData.formMataData_json}
              appDesignerCallback={props?.Callback}
              containerId={containerId}
            />
          </Suspense>,
          document.getElementById(containerId)
        );
  
      // }, 2000);
    }
    else{
        ReactDOM.render(
          <Suspense fallback={<div className="Loading_fallback">{loadingTranslation[translationStyles1] || "Loading ...."}</div>}>
            <App 
              childComp="preview" 
              history={props} 
              data={props.passedData} 
              formMataData={props.passedData.formMataData_json}
              appDesignerCallback={props?.Callback}
              containerId={containerId}
            />
          </Suspense>,
          document.getElementById(containerId)
        );
    
    }  
};

window.renderPreviewInFrame = (containerId, props) => {

  if(props.ContainerId==="ngform"){
    window.istaskOpen= true;
  }
  else{
    window.istaskOpen= false;
  }
  formStateStore.dispatch(updateContainerInfo({key:containerId}));
  window.formLoaderRan = false;
  window.langChange = false; // when lang is present in QueryParam 
  formStateStore.dispatch(updateStateInRedux({name:"generalDataCall",value: false}));
  ReactDOM.render(
      <Suspense fallback={<div className="Loading_fallback">{loadingTranslation[translationStyles1] || "Loading ...."}</div>}>
        <App 
          childComp="preview" 
          history={props} 
          data={props.passedData} 
          formMataData={props.passedData.formMataData_json}
          appDesignerCallback={props?.Callback} 
          containerId={containerId}
        />
      </Suspense>,
    document.getElementById(containerId)
  );
};

// Reusable Business Function
window.renderReusableBusinessFunction = (containerId, props) => {
  formStateStore.dispatch(updateContainerInfo({key:containerId}));
  window.formLoaderRan = false;
  window.langChange = false; // when lang is present in QueryParam 
  formStateStore.dispatch(updateStateInRedux({name:"generalDataCall",value: false}));
  ReactDOM.render(
    <Suspense fallback={<div className="Loading_fallback">{loadingTranslation[translationStyles1] || "Loading ...."}</div>}>
      <App 
          childComp="reusableFunction" 
          history={props} 
          data={props.passedData} 
          formMataData={props.passedData.formMataData_json}
          appDesignerCallback={props?.Callback} 
          containerId={containerId}
        />
    </Suspense>,
    document.getElementById(containerId)
  )
}

window.unmountPreview = containerId => {
  if(document.getElementById(containerId)){
    window.istaskOpen= false;
    return ReactDOM.unmountComponentAtNode(document.getElementById(containerId));
  }
};


window.unmountPreviewManual = (containerId) => {
  if(document.getElementById(containerId)){
    window.istaskOpen= false;
    return ReactDOM.unmountComponentAtNode(document.getElementById(containerId));
  }
};


window.unmountPreviewInFrame = containerId => {
  if(document.getElementById(containerId)){
    window.istaskOpen= false;
    return ReactDOM.unmountComponentAtNode(document.getElementById(containerId));
  }
};

//  ************************************** ************************************** **************************************************

// ***********************************  MicroFrontend component implementation for MDM Module **************************************
window.renderApp = (containerId, props) => {
  formStateStore.dispatch(updateContainerInfo({key:containerId}));
  ReactDOM.render(
      <Suspense fallback={<div className="Loading_fallback">{loadingTranslation[translationStyles1] || "Loading ...."}</div>}>
        <App 
          childComp="app" 
          history={props} 
          data={props.passedData} 
          appDesignerCallback={props?.Callback} 
          containerId={containerId}
        />
      </Suspense>,
    document.getElementById(containerId)
  );
};

window.unmountApp = containerId => {
  ReactDOM.unmountComponentAtNode(document.getElementById(containerId));
};

window.postToApp = ({ type, payload}) =>{

  switch(type){
    case "applicationPages":  
  }
}

if ( (window.formBuilder_containerId_mf && !document.getElementById(window.formBuilder_containerId_mf)) || window.formBuilder_containerId_mf===undefined ) {
    formStateStore.dispatch(updateContainerInfo({key:"default"}));
     ReactDOM.render(
      <Suspense fallback={<div className="Loading_fallback">{loadingTranslation[translationStyles1] || "Loading ...."}</div>}>
        <App childComp="app" containerId={"default"} />
      </Suspense>
        , document.getElementById('newapplyonline_root_not_mf'));
}

// ************************************** ************************************************************************************************************************ //


// ****************************************************************** MICROFRONTE END IMPLEMENTTAION ************************************************************* //

window.MdmDataModel = function (appId , appName){
  var props = {
   "Module": "MDM",
   "Component": "DataModelListViewer",
   "InFrame": false,
   "ContainerId": "dataModel_mf",
   "Renderer":"renderDataModelListViewer",
   "Callback":null,
   "source": "AP",
   "auto_generate_table": true,
   "object_type": "AP",
   "object_id": appId,
   "object_name": appName || "Application Name",
   "default_data_fields": [
      {
        "name": "referencekey",
        "alias": "referencekey",
        "type": 1,
        "key_field": true,
        "id": 1
      }
    ],
    data_types: [1,2,3,4,5,8,9,10],
   "Unmount": "unmountDataModelListViewer"
  }
  if(window && window?.loadMicroFrontend ){
    window.loadMicroFrontend(props);
  }
}

window.openDocumentViewer = function (translation, dir, docClicked, docData, containerId){
  var doc_viewer_props = {
    "t":translation || "",
    "direction":dir,
    "source" :"IFORM",
    "dms_type" : docData.dms_type || "1",
    "isPortal" : docData.isPortal,
    "documentInfoProps": docClicked,
    "SetDocumentDataProps": {
              available_doc_types: docData?.available_doc_types,
              upload_doc_as: docData?.upload_doc_as,
              documents: docData?.documents
            },
    "Component": "DocumentViewer",
    "Module": "DOCFR",
    "InFrame": false,
    "ContainerId": containerId
  }
      if(window && window?.loadMicroFrontend ){
        window.loadMicroFrontend(doc_viewer_props);
      }
}

window.loadIntegrator = function () {
  const path = `/integration/integration.js?version=${Math.floor(Math.random()*10000)}`;
  const script = document.createElement('script');
    script.type= "text/javascript";
    script.src = path;
    script.onload= () => {
      window.docListIntegratorPresent= true;
    }
    document.head.appendChild(script);
}

var loadSessionPopup_count=0;
window.loadSessionPopup = function (props) {
  if (window && window?.loadMicroFrontend && window.MicroAppsMap && Object.keys(window.MicroAppsMap).length > 0 ) {
    window.loadMicroFrontend(props);
  }
  else if (loadSessionPopup_count < 5){
    window.setTimeout(()=>{
      loadSessionPopup_count = loadSessionPopup_count + 1;
      window.loadSessionPopup(props);
    },2000);
  }
};

window.loadIntegrator_bam = function () {
  const path = `/integration/integration.js?version=${Math.floor(Math.random()*10000)}`;
  const script = document.createElement('script');
    script.type= "text/javascript";
    script.src = path;
    script.onload= () => {
       window.docListIntegratorPresent= true;
    }
    document.head.appendChild(script);
}

window.docListIntegratorPresent= false;
window.loadDoclistComponent = function (loadDoc, docData) {
  const scriptInt = document.createElement('script')
  scriptInt.type = 'text/javascript'
  scriptInt.src =`/integration/integration.js?version=${Math.floor(Math.random()*10000)}`;
  scriptInt.id= "loadDoclistIntegration"
  scriptInt.onload= () => {
 }
  document.body.appendChild(scriptInt)  

  return true
}

window.loadDoclist = function (props){
  window?.loadMicroFrontend(props);
}

window.loadMicroFrontend_formBuilder = function (props){
  window.loadMicroFrontend(props);
}
window.MdmDataObjectsModel = function (props) {
  if (window && window?.loadMicroFrontend) {
    window.loadMicroFrontend(props);
  }
};

window.SessionHandler = function (props) {
  if (window && window?.loadMicroFrontend) {
    window.loadMicroFrontend(props);
  }
};

swDev();